"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var undef = undefined;
/**
 * Neccessary so that all new items being inserted into an array can be reflected and proxied
 * if neccesary (e.g. dynamic objects), and any existing proxies can be deleted or shifted as items
 * are removed.
 */
var proxiedSplice = function (arr, proxyNode, args) {
    var deleted = [];
    var startIndex = args[0], newItems = args.slice(2);
    if (startIndex === undef)
        return deleted;
    var proxy = proxyNode.proxy;
    var proxies = proxyNode.children;
    var newItemsCount = newItems.length;
    var len = arr.length;
    // Normalise parameters as per spec
    var normalStartIndex = startIndex < 0
        ? Math.max(0, arr.length + startIndex)
        : Math.min(arr.length, startIndex);
    var deleteCount = args[1];
    if (deleteCount === undef && newItems.length === 0)
        return deleted;
    deleteCount = Math.max(0, Math.min(deleteCount, arr.length - normalStartIndex));
    var rotationAmount = newItemsCount - deleteCount;
    var i = rotationAmount < 0 ? normalStartIndex + deleteCount : len - 1;
    // Delete all items and proxies to be deleted
    while (deleteCount) {
        var deleteIndex = normalStartIndex + (deleteCount - 1);
        deleted.unshift(arr[deleteIndex]);
        delete arr[deleteIndex];
        if (proxies) {
            delete proxies[deleteIndex];
        }
        deleteCount--;
    }
    // Rotate remaining items forward/backward, and delete expired proxies.
    // Proxies can not be rotated, as they contain closed-over paths which can
    // not be shifted. They must instead be regenerated on next patch.
    for (;;) {
        if (rotationAmount === 0 ||
            (rotationAmount < 0 && i >= len) ||
            (rotationAmount > 0 && i < normalStartIndex + deleteCount))
            break;
        var tempValue = arr[i];
        arr[i + rotationAmount] = tempValue;
        if (proxies) {
            delete proxies[i + rotationAmount];
            delete proxies[i];
        }
        i = rotationAmount < 0 ? i + 1 : i - 1;
    }
    // Insert new items via proxy index assignments
    while (newItems.length) {
        var newItem = newItems.pop();
        proxy[normalStartIndex + newItems.length] = newItem;
    }
    // Adjust array length as needed
    arr.length = len + rotationAmount;
    return deleted;
};
exports.default = proxiedSplice;
//# sourceMappingURL=proxiedSplice.js.map